// eslint-disable-next-line no-unused-vars
import React from 'react';
import { GlobalState } from '@leverege/ui-redux';
import { Button } from '@leverege/ui-elements';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const handleOpenNewTab = newURL => {
  const newWindow = window.open(newURL, '_blank', 'noopener,noreferrer');
  if (newWindow) newWindow.opener = null;
};
export default function OpenInJohnDeereButton(props) {
  const {
    object
  } = props;
  const equipmentId = object.id;
  const equipment = GlobalState.get().models.lookup?.[equipmentId];
  const integrationStatus = equipment.data?.johnDeere?.integrationStatus;
  const jdEquipmentId = equipment.data?.johnDeere?.equipment?.id;
  if (!integrationStatus || !jdEquipmentId || integrationStatus === 'inactive') {
    return null;
  }
  const johnDeereEquipmentUrl = `https://map.deere.com/machines/${jdEquipmentId}?orgEquipmentId=true`;
  return /*#__PURE__*/_jsxs(Button, {
    variant: "secondary",
    style: {
      width: '93%'
    },
    width: "100%",
    onClick: () => handleOpenNewTab(johnDeereEquipmentUrl),
    children: ["Open In John Deere", /*#__PURE__*/_jsx("i", {
      className: "fak fa-lv-link-out"
    })]
  });
}